import { Resource } from './resource';

export interface CitizenReport extends Resource {
    attachments: Attachment[];
    dateCreated: Date;
    location: Location;
    sender: Sender;
    answer?: Answer;
    missionId?: string;
}

export interface Location {
    type: string;
    coordinates: number[];
}

export interface Sender {
    id: string;
    name: string;
}
export interface Attachment {
    attachmentType: AttachmentType;
    text: string;
    url: string;
    extra?: string;
}

export interface Answer {
    dateSent: string;
    text: string;
}

export interface Location {
    type: string;
    coordinates: number[];
}

export enum AttachmentType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO'
}
